import { Result, Button } from 'antd'

interface Props {
  message?: string
  error?: unknown
  onRetry?: () => void
}

function resolvePresentation(message?: string, error?: unknown): { title: string; subTitle: string } {
  const fallback = message || (error instanceof Error ? error.message : '') || '加载失败，请重试'
  const kind = error instanceof Error && 'kind' in error ? String((error as { kind?: string }).kind || '') : ''

  if (kind === 'unauthorized') {
    return { title: '认证失败', subTitle: fallback }
  }
  if (kind === 'forbidden') {
    return { title: '无权访问', subTitle: fallback }
  }
  if (kind === 'cors') {
    return {
      title: '跨域请求被拦截',
      subTitle:
        fallback ||
        '跨域请求被拦截，请检查 VITE_API_BASE_URL 配置或 API CORS 设置。修改 .env 后需重启 Vite dev server。',
    }
  }
  if (kind === 'network') {
    return { title: '网络连接失败', subTitle: fallback }
  }
  if (kind === 'server') {
    return { title: '服务器错误', subTitle: fallback }
  }
  return { title: '加载异常', subTitle: fallback }
}

export default function ErrorResult({ message, error, onRetry }: Props) {
  const presentation = resolvePresentation(message, error)

  return (
    <Result
      status="error"
      title={presentation.title}
      subTitle={presentation.subTitle}
      extra={
        onRetry && (
          <Button type="primary" onClick={onRetry}>
            重试
          </Button>
        )
      }
    />
  )
}
